/* RnR motion (24 Sep 2026). One quiet thing: as an RnR section scrolls into
   view, its heading and then its items ease up into place, once. Nothing moves
   again after that, and nothing on the first screen moves at all.

   - Only what starts below the fold is ever hidden, and only by this script,
     so a page without JavaScript, or one where this fails, shows everything.
   - Items in a row follow each other by a few hundredths of a second, capped,
     so a long grid never makes anyone wait.
   - Sliders and marquees (anything that scrolls sideways) are left alone.
   - Off entirely for anyone who has asked their device for less motion.

   On when Theme settings > RnR > "Ease sections in on scroll" is ticked. To
   preview it before then, add ?motion=1 to any page; ?motion=0 turns the
   preview off again. */
(function () {
  var root = document.documentElement;
  try {
    var q = new URLSearchParams(location.search).get('motion');
    if (q === '1') sessionStorage.setItem('rnrMotion', '1');
    if (q === '0') sessionStorage.removeItem('rnrMotion');
  } catch (e) {}
  var preview = false;
  try { preview = sessionStorage.getItem('rnrMotion') === '1'; } catch (e) {}
  if (root.getAttribute('data-rnr-motion') !== 'true' && !preview) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  var GROUPS = 'ul, ol, [class*="__grid"], [class*="__cards"], [class*="__list"], [class*="__figs"], [class*="__pills"], [class*="__tabs"], [class*="__items"], [class*="__row"]';
  var HEADS = 'h2, [class*="__intro"], [class*="__lead"]';
  var SKIP = '.rnr-installs, [data-rnr-hl], .rnr-marquee, header, footer, nav, form, [role="tablist"], .rnr-product-card__specs, .rnr-bgrid__lines, .rnr-frame__covers li, details';

  function scrollsSideways(el) {
    var o = getComputedStyle(el).overflowX;
    return o === 'auto' || o === 'scroll';
  }

  function collect(section) {
    var picked = [];
    section.querySelectorAll(HEADS).forEach(function (h) {
      if (h.closest(SKIP)) return;
      picked.push({ el: h, d: 0 });
    });
    section.querySelectorAll(GROUPS).forEach(function (g) {
      if (g.closest(SKIP) || scrollsSideways(g)) return;
      var kids = Array.prototype.filter.call(g.children, function (c) {
        return c.nodeType === 1 && c.offsetHeight > 0;
      });
      if (kids.length < 2) return;
      // A list inside something already moving would move twice.
      if (picked.some(function (p) { return p.el.contains(g); })) return;
      kids.forEach(function (c, i) { picked.push({ el: c, d: Math.min(i, 5) * 70 }); });
    });
    return picked;
  }

  function settle(el) {
    el.classList.remove('rnr-rv', 'rnr-rv-in');
    el.style.removeProperty('--rv-d');
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      el.classList.add('rnr-rv-in');
      var done = function (ev) {
        if (ev && ev.target !== el) return;
        el.removeEventListener('transitionend', done);
        settle(el);
      };
      el.addEventListener('transitionend', done);
      setTimeout(function () { settle(el); }, 1600);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

  /* Safety net. Anything still waiting that is on screen, or everything still
     waiting once the reader reaches the bottom of the page, shows at once.
     Images loading late can move things after the observer has looked, and
     nothing on this site should ever stay hidden because of motion. */
  var ticking = false;
  function sweep() {
    ticking = false;
    var waiting = document.querySelectorAll('.rnr-rv:not(.rnr-rv-in)');
    if (!waiting.length) { window.removeEventListener('scroll', onScroll); return; }
    var atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
    waiting.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (atEnd || (r.top < window.innerHeight && r.bottom > 0)) {
        io.unobserve(el);
        el.classList.add('rnr-rv-in');
        setTimeout(function () { settle(el); }, 1600);
      }
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', sweep);

  function start() {
    var fold = window.innerHeight * 0.92;
    document.querySelectorAll('.rnr-section').forEach(function (section) {
      if (section.getBoundingClientRect().top < fold && section.getBoundingClientRect().bottom < fold) return;
      collect(section).forEach(function (p) {
        if (p.el.classList.contains('rnr-rv')) return;
        if (p.el.getBoundingClientRect().top < fold) return; // already on screen: leave it be
        if (p.d) p.el.style.setProperty('--rv-d', p.d + 'ms');
        p.el.classList.add('rnr-rv');
        io.observe(p.el);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
